import { AxiosRequestConfig } from 'axios';
import vm from '@/main';
import { OTHER_PATHS_NEEDING_SITE_ID, NO_SITE_ID_PATHS } from '../helpers/const';
import { conditionalSiteIdPaths } from '../helpers/rules';

/**
 * Middleware to inject the `siteId` into the request params.
 */
export const siteIdMiddleware = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const app = vm();

  if (
    (
      config.url?.includes('/website-api/')
      || OTHER_PATHS_NEEDING_SITE_ID.some((path) => config.url?.includes(path))
      || conditionalSiteIdPaths.some((isValid) => isValid(config))
    )
    && !NO_SITE_ID_PATHS.some((path) => config.url?.includes(path))
  ) {
    config.params = {
      ...config.params,
      ...app?.$route.params.websiteId && { siteId: app?.$route.params.websiteId },
    };
  }

  return config;
};
